<p>{{ 'EXTERNAL_REDIRECT.REDIRECTING' | translate}}</p>
